// src/components/shared/forms/atomic/FieldTypes.jsx
import React from 'react';
import { Calendar, Clock, MapPin, Mail, Phone, File, FileText, Video, Link, Hash, Type, Image, List, ToggleLeft } from 'lucide-react';

export const FIELD_TYPES = {
  // Basic Types
  TEXT: 'text',
  TEXTAREA: 'textarea', 
  NUMBER: 'number',
  EMAIL: 'email',
  PHONE: 'tel',
  URL: 'url',
  PASSWORD: 'password',
  
  // Date/Time Types
  DATE: 'date',
  TIME: 'time',
  DATETIME: 'datetime-local',
  
  // Selection Types
  SELECT: 'select',
  MULTISELECT: 'multiselect',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  
  // Special Types
  TOGGLE: 'toggle',
  IMAGE: 'image',
  FILE: 'file',
  RICH_TEXT: 'rich_text',
  JSON: 'json',
  
  // Composite Types
  LIST: 'list',
  OBJECT: 'object',
  ADDRESS: 'address',
  CURRENCY: 'currency',

  // File Types
  IMAGE: 'image',
  FILE: 'file',
  DOCUMENT: 'document',
  MEDIA: 'media',
  ATTACHMENT: 'attachment'
};

export const getFieldIcon = (type) => {
  const icons = {
    [FIELD_TYPES.EMAIL]: Mail,
    [FIELD_TYPES.PHONE]: Phone,
    [FIELD_TYPES.URL]: Link,
    [FIELD_TYPES.DATE]: Calendar,
    [FIELD_TYPES.TIME]: Clock,
    [FIELD_TYPES.IMAGE]: Image,
    [FIELD_TYPES.FILE]: File,
    [FIELD_TYPES.DOCUMENT]: FileText,
    [FIELD_TYPES.MEDIA]: Video,
    [FIELD_TYPES.ATTACHMENT]: File,
    [FIELD_TYPES.LIST]: List,
    [FIELD_TYPES.TOGGLE]: ToggleLeft,
    [FIELD_TYPES.NUMBER]: Hash,
    [FIELD_TYPES.ADDRESS]: MapPin
  };
  return icons[type] || Type;
};